import React, { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Table } from 'react-bootstrap';
import PropTypes from 'prop-types';

import { useFilters } from '../../../../providers/Filters/useFilters';
import { generateAccessMassDrop, constants } from '../../helpers';
import useShiftSelected from '../../../../utils/hooks/useShiftSelected';

import TableRows from './tableRows';
import TableBody from './tableBody';
import TableHead from './tableHead';

const OrdersTable = ({
  handleSelect,
  values,
  setValues,
  config,
  access,
  orders,
  bulkActions,
  isTableLoading,
}) => {
  const { t } = useTranslation();
  const { filters } = useFilters()

  const ordersIds = useMemo(
    () => orders
      .filter((item) => {
        if (Number(filters.query.status) === constants.STATUS_CANCELED) {
          return Number(item.status) !== constants.STATUS_AWAITING;
        }
        return Number(item.status) !== constants.STATUS_CANCELED && Number(item.status) !== constants.STATUS_AWAITING;
      })
      .map((item) => item.id),
    [orders, filters.query.status],
  );

  const accessMassActions = generateAccessMassDrop(config?.access, t, filters.query, bulkActions?.actions, orders);

  const onChange = useShiftSelected(ordersIds, values);

  const onChangeCheck = (event, order) => {
    if (accessMassActions.length === 0 || !orders) {
      return;
    }

    const nextValue = onChange(event, order.id);

    setValues(nextValue);
  };

  const onChangeCheckAll = (e) => {
    if (accessMassActions.length === 0 || !orders) {
      return;
    }

    if (e.target.value === 'checkAll' && e.target.checked) {
      return setValues([
        ...orders
          .filter((item) => {
            if (Number(filters.query.status) === constants.STATUS_CANCELED) {
              return Number(item.status) !== constants.STATUS_AWAITING;
            }
            return Number(item.status) !== constants.STATUS_CANCELED && Number(item.status) !== constants.STATUS_AWAITING;
          })
          .map((item) => item.id),
      ]);
    }
    if (e.target.value === 'checkAll' && !e.target.checked) {
      return setValues([]);
    }
  };

  return (
    <>
      <Table className="table-grey table__orders">
        <TableHead
          orders={orders}
          values={values}
          setValues={setValues}
          handleSelect={handleSelect}
          onChangeCheck={onChangeCheckAll}
          config={config}
          access={access}
          accessMassActions={accessMassActions}
          queryString={filters.query}
          bulkActions={bulkActions}
        />
        <TableBody values={values} orders={orders} isTableLoading={isTableLoading}>
          <TableRows
            orders={orders}
            values={values}
            onChangeCheck={onChangeCheck}
            handleSelect={handleSelect}
            config={config}
            access={access}
            accessMassActions={accessMassActions}
            isTableLoading={isTableLoading}
            queryString={filters.query}
          />
        </TableBody>
      </Table>
    </>
  );
};

OrdersTable.propTypes = {
  handleSelect: PropTypes.func,
  values: PropTypes.array,
  setValues: PropTypes.func,
  config: PropTypes.object,
  access: PropTypes.object,
  orders: PropTypes.array,
  bulkActions: PropTypes.object,
  isTableLoading: PropTypes.bool,
};

export default memo(OrdersTable);
